import React from 'react';

const Users = () => {
    return (
        <div>Hi</div>
    )
}

export default Users